<payee-popup [heading]="'CLIENT_ACCESS.ADD.TITLE' | translate">
  @if (initLoading()) {
    <mat-progress-spinner
      color="accent"
      mode="indeterminate"
      diameter="100"
    ></mat-progress-spinner>
  }

  @if (!initLoading()) {
    <form
      data-testid="add-client-dialog"
      [formGroup]="formGroup"
    >
      <div>
        {{ "CASE_FORM.FORMS.CLIENT.TYPE_LABEL" | translate }}
      </div>
      <div
        class="flex vcenter client-type"
        data-testid="add-client-type-selector"
      >
        <button
          payee-button
          width="auto"
          data-testid="add-client-type-org"
          [isBorderButton]="client_type.value !== 'org'"
          [color]="client_type.value === 'org' ? 'undefined' : 'white'"
          (click)="client_type.patchValue('org')"
        >
          <span>{{ "CASE_FORM.FORMS.CLIENT.TYPE_SELECTOR.ORG" | translate }}</span>
        </button>
        <button
          payee-button
          width="auto"
          data-testid="add-client-type-house"
          [isBorderButton]="client_type.value !== 'house'"
          [color]="client_type.value === 'house' ? 'undefined' : 'white'"
          (click)="client_type.patchValue('house')"
        >
          <span>{{ "CASE_FORM.FORMS.CLIENT.TYPE_SELECTOR.HOUSE" | translate }}</span>
        </button>
      </div>
      <payee-form-field
        width="max"
        class="top-margin-15"
      >
        <span payee-label>
          {{
            (client_type.value === "org" ? "CASE_FORM.FORMS.CLIENT.ORG.NAME_PLACEHOLDER" : "CASE_FORM.FORMS.CLIENT.HOUSE.NAME_PLACEHOLDER")
              | translate
          }}
        </span>
        <input
          payee-input
          formControlName="name"
          data-testid="add-client-name"
          [matAutocomplete]="auto"
          (input)="onCompanySearchInput($event)"
        />
        @if (companySearchService.autocompleteSearchLoading) {
          <span payee-suffix>
            <mat-progress-spinner
              mode="indeterminate"
              diameter="24"
            ></mat-progress-spinner>
          </span>
        }
        <mat-autocomplete
          #auto="matAutocomplete"
          [requireSelection]="false"
          (optionSelected)="companySelected($event)"
        >
          @for (option of autocompleteOptions; track option.tax_number || option.name) {
            <mat-option [value]="option">
              {{ option.short_name || option.name }}
            </mat-option>
          }
        </mat-autocomplete>
        @if (name.invalid && name.dirty) {
          <ng-container payee-error>
            @if (name.hasError("required")) {
              <span>{{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}</span>
            }
            @if (name.hasError("maxlength")) {
              <span>{{ "ERROR_MESSAGES.MAXLENGTH" | translate }}</span>
            }
          </ng-container>
        }
      </payee-form-field>
      <payee-form-field
        width="max"
        class="top-margin-15"
      >
        <span payee-label>{{ "CASE_FORM.FORMS.CLIENT.ORG.TAX_NUMBER_PLACEHOLDER" | translate }}</span>
        <input
          payee-input
          formControlName="tax_number"
        />
        @if (tax_number.invalid && tax_number.dirty) {
          <ng-container payee-error>
            @if (tax_number.hasError("required")) {
              <span>{{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}</span>
            }
            @if (tax_number.hasError("maxlength")) {
              <span>{{ "ERROR_MESSAGES.MAXLENGTH" | translate }}</span>
            }
          </ng-container>
        }
      </payee-form-field>
      @if (client_type.value === "org") {
        <payee-form-field
          width="max"
          class="top-margin-15"
        >
          <span payee-label>{{ "CASE_FORM.FORMS.CLIENT.ORG.REGISTRATION_NUMBER_PLACEHOLDER" | translate }}</span>
          <input
            payee-input
            formControlName="registration_number"
          />
        </payee-form-field>
      }
      <div class="top-margin-15">
        {{
          (client_type.value === "org"
            ? "CASE_FORM.FORMS.CLIENT.ORG.HEADQUARTERS_LABEL"
            : "CASE_FORM.FORMS.CLIENT.HOUSE.HEADQUARTERS_LABEL"
          ) | translate
        }}
      </div>
      <form formGroupName="address">
        @if (countryOptions.length) {
          <payee-form-field
            width="max"
            class="top-margin-15"
          >
            <span payee-label>{{ "ADD_NEW_CLIENT.FORM.ADDRESS.COUNTRY" | translate }}</span>
            <payee-autocomplete
              formControlName="country_iso"
              [options]="countryOptions"
              [displayWith]="countryDisplayWith"
            ></payee-autocomplete>
            @if (country_iso.invalid && country_iso.dirty) {
              <ng-container payee-error>
                @if (country_iso.hasError("required")) {
                  <span>{{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}</span>
                }
              </ng-container>
            }
          </payee-form-field>
        }
        <payee-form-field width="max">
          <span payee-label>{{ "CASE_FORM.FORMS.CLIENT.ORG.POSTCODE_PLACEHOLDER" | translate }}</span>
          <input
            payee-input
            formControlName="postcode"
            data-testid="add-client-postcode"
          />
          @if (postcode.invalid && postcode.dirty) {
            <ng-container payee-error>
              @if (postcode.hasError("required")) {
                <span>{{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}</span>
              }
              @if (postcode.hasError("maxlength")) {
                <span>{{ "ERROR_MESSAGES.MAXLENGTH" | translate }}</span>
              }
            </ng-container>
          }
        </payee-form-field>
        <payee-form-field width="max">
          <span payee-label>{{ "CASE_FORM.FORMS.CLIENT.ORG.SETTLEMENT_PLACEHOLDER" | translate }}</span>
          <input
            payee-input
            formControlName="settlement"
            data-testid="add-client-settlement"
          />
          @if (settlement.invalid && settlement.dirty) {
            <ng-container payee-error>
              @if (settlement.hasError("required")) {
                <span>{{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}</span>
              }
              @if (settlement.hasError("maxlength")) {
                <span>{{ "ERROR_MESSAGES.MAXLENGTH" | translate }}</span>
              }
            </ng-container>
          }
        </payee-form-field>
        <payee-form-field
          width="max"
          class="top-margin-15"
        >
          <span payee-label>{{ "CASE_FORM.FORMS.CLIENT.ORG.STREET_PLACEHOLDER" | translate }}</span>
          <input
            payee-input
            formControlName="street"
            data-testid="add-client-street"
          />
          @if (street.invalid && street.dirty) {
            <ng-container payee-error>
              @if (street.hasError("required")) {
                <span>{{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}</span>
              }
              @if (street.hasError("maxlength")) {
                <span>{{ "ERROR_MESSAGES.MAXLENGTH" | translate }}</span>
              }
            </ng-container>
          }
        </payee-form-field>
      </form>
      @if (mother_name.enabled) {
        <payee-form-field
          width="max"
          class="top-margin-15"
        >
          <span payee-label>{{ "CASE_FORM.FORMS.CLIENT.HOUSE.MOTHER_NAME_PLACEHOLDER" | translate }}</span>
          <input
            payee-input
            formControlName="mother_name"
          />
          @if (mother_name.invalid && mother_name.dirty) {
            <ng-container payee-error>
              @if (mother_name.hasError("required")) {
                <span>{{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}</span>
              }
              @if (mother_name.hasError("maxlength")) {
                <span>{{ "ERROR_MESSAGES.MAXLENGTH" | translate }}</span>
              }
            </ng-container>
          }
        </payee-form-field>
      }
      @if (birth_place.enabled) {
        <payee-form-field
          width="max"
          class="top-margin-15"
        >
          <span payee-label>{{ "CASE_FORM.FORMS.CLIENT.HOUSE.BIRTH_PLACE_PLACEHOLDER" | translate }}</span>
          <input
            payee-input
            formControlName="birth_place"
          />
          @if (birth_place.invalid && birth_place.dirty) {
            <ng-container payee-error>
              @if (birth_place.hasError("required")) {
                <span>{{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}</span>
              }
              @if (birth_place.hasError("maxlength")) {
                <span>{{ "ERROR_MESSAGES.MAXLENGTH" | translate }}</span>
              }
            </ng-container>
          }
        </payee-form-field>
      }
      @if (birth_date.enabled) {
        <payee-form-field
          width="max"
          class="top-margin-15"
        >
          <span payee-label>{{ "CASE_FORM.FORMS.CLIENT.HOUSE.BIRTH_DATE_PLACEHOLDER" | translate }}</span>
          <payee-datepicker
            [formControl]="birth_date"
            [max]="maxBirthDate"
          ></payee-datepicker>
          @if (birth_date.invalid && birth_date.dirty) {
            <ng-container payee-error>
              @if (birth_date.hasError("required")) {
                <span>{{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}</span>
              }
              @if (birth_date.hasError("maxdate")) {
                <span>{{ "CASE_FORM.FORMS.CLIENT.HOUSE.ERRORS.MAX_DATE" | translate }}</span>
              }
              @if (birth_date.hasError("unknown")) {
                <span>{{ birth_date.errors?.unknown }}</span>
              }
            </ng-container>
          }
        </payee-form-field>
      }
      @if (formGroup.hasError("duplicate")) {
        <span color="alert-red">
          {{ "ERROR_MESSAGES.DUPLICATE_TAX_NUMBER" | translate }}
        </span>
      }
    </form>
  }

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      data-testid="add-client-submit"
      [disabled]="formGroup.invalid || submitLoading"
      (click)="submit()"
    >
      {{ "CLIENT_ACCESS.ADD.SUBMIT" | translate }}
    </button>
  </ng-template>
  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="white"
      width="max"
      mat-dialog-close
      [isBorderButton]="true"
    >
      {{ "CANCEL" | translate }}
    </button>
  </ng-template>
</payee-popup>
